import {
  isSharesProject,
  type Project,
} from "@tudigo-monorepo/core-tudigo-api-models";

type Scenario = "middle" | "capitalized";

type InternalRateOfReturn = {
  value: number | null | undefined;
  scenario: Scenario;
};

export function getProjectInternalRateOfReturn(
  project: Project,
): InternalRateOfReturn | null {
  if (!isSharesProject(project)) {
    return null;
  }

  const targetedYield = project.sharesMechanicSettings?.targetedYield;
  const internalNoDecimalRateOfReturn =
    project.sharesMechanicSettings?.internalNoDecimalRateOfReturn;
  const buyPack = project.sharesMechanicSettings?.buyPack;

  const internalRateOfReturn: InternalRateOfReturn = {
    value: targetedYield?.mediumInPercent,
    scenario: "middle",
  };

  if (buyPack) {
    internalRateOfReturn.value = internalNoDecimalRateOfReturn;
    internalRateOfReturn.scenario = "capitalized";
  }

  return internalRateOfReturn;
}
